<template>
  <span>
    <v-icon size="small" class="pol-icon">mdi-check-circle-outline</v-icon>POL
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'POLIcon',
})
</script>

<style lang="scss" scoped>
.pol-icon {
  margin-bottom: 3px;
  margin-right: 4px;
}
</style>
